$('#modal').modal();

$('#modal').on($.modal.CLOSE, function(event, modal){
    $(this).remove();
    $.get("/set_cookie", function(data, status){
    });
});
